import { render, staticRenderFns } from "./QuoteHistoryDisplay.vue?vue&type=template&id=28b8fd84&scoped=true&"
import script from "./QuoteHistoryDisplay.vue?vue&type=script&lang=js&"
export * from "./QuoteHistoryDisplay.vue?vue&type=script&lang=js&"
import style0 from "./QuoteHistoryDisplay.vue?vue&type=style&index=0&id=28b8fd84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b8fd84",
  null
  
)

export default component.exports